// extracted by mini-css-extract-plugin
export var active = "bw_bd";
export var categories = "bw_c1";
export var category = "bw_c2";
export var icon = "bw_bq";
export var icons = "bw_bw";
export var image = "bw_g";
export var member = "bw_gM";
export var memberTitle = "bw_gN";
export var name = "bw_fD";
export var placeholder = "bw_bb";
export var section = "bw_d";
export var show = "bw_L";
export var subtitle = "bw_cj";
export var team = "bw_gL";